import styled from 'styled-components/macro'
import { DefaultTitleXLargeFactory } from '../core/Typograph/Typograph.Style'

export const Title = styled.h2(({ theme }) => ({
    ...DefaultTitleXLargeFactory({ theme })
})) 

export const Container = styled.div(({ theme }) =>({
    display: 'flex',
    alignItems: 'center',
    gap: 12,
    margin: '32px 0',

    [theme.breakpoint.lg()]: {
        margin: '60px 0', 
    }
}))